<div class="modal-content">
	<div class="modal-header">
		<h5 class="modal-title" data-testid="SUBSYS4_CONFIRMATION_MODAL_TITLE_TXT">
			{{ config?.title || labels().CONFIRMATION_COMPONENT_TITLE }}
		</h5>
		<button type="button" class="hide-focus"></button>
	</div>
	<div class="modal-body" data-testid="SUBSYS4_CONFIRMATION_MODAL_TEXT_TXT"
		[innerHtml]="config?.message || labels().CONFIRMATION_COMPONENT_TEXT">
	</div>
	<div class="modal-footer">
		@if (config?.isCancelBtn) {
		<button data-testid="SUBSYS4_CONFIRMATION_MODAL_CANCEL_BTN" type="button" class="btn btn-secondary-outline"
			(click)="activeModal.dismiss()">
			{{ config?.cancelBtn || labels().CONFIRMATION_COMPONENT_CANCEL_BUTTON }}
		</button>
		}
		<button data-testid="SUBSYS4_CONFIRMATION_MODAL_CONFIRM_BTN" type="button" class="btn btn-primary"
			(click)="activeModal.close()">
			{{ config?.confirmBtn || labels().CONFIRMATION_COMPONENT_CONFIRM_BUTTON }}
		</button>
	</div>
</div>